import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'geos';

  scrollToElement($element): void {    
    $element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});    
    //setTimeout(function() { $('#claims').modal('hide'); }, 2000);
  }
}
